import { Group } from '@mantine/core';
import { useSuspenseQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

import { ExportExcelButton } from '@/module/Export';

import { AddButtonLink, Browse, usePagination } from '@/core/components';

import { FilterBox, SearchFilter, useSearch, useSortDirection } from '@feature/utils';

import { AwardCard } from './components/Card/AwardCard';
import { getAwardPagedOptions } from './model/AwardQuery';

export function AwardBrowse() {
  const { t } = useTranslation();
  const { sortDirection, toggleSortDirection } = useSortDirection('DESC');
  const { search, searchProps } = useSearch();
  const { pagination, useTotalElements, ...paginationProps } = usePagination({ search });

  const { data } = useSuspenseQuery(
    getAwardPagedOptions({
      ...pagination,
      sortDirection,
      search,
    }),
  );
  useTotalElements(data);

  return (
    <Browse
      actions={
        <Group>
          <ExportExcelButton entityType="awards" />
          <AddButtonLink />
        </Group>
      }
      title={t('awards.title')}
      pagination={paginationProps}
      filters={
        <FilterBox>
          <SearchFilter
            label={t('label.search')}
            description={t('awards.searchBy')}
            {...searchProps}
          />
        </FilterBox>
      }
      sortDirection={sortDirection}
      sortedBy={t('awards.sortedByPublishDate')}
      toggleSortDirection={toggleSortDirection}
      data={data.list}
      renderItem={award => (
        <AwardCard
          key={award.id}
          award={award}
          to={`${award.id}`}
        />
      )}
    />
  );
}
